import { render, staticRenderFns } from "./ScreenRequest.vue?vue&type=template&id=79db4f4c&scoped=true"
import script from "./ScreenRequest.vue?vue&type=script&lang=js"
export * from "./ScreenRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79db4f4c",
  null
  
)

export default component.exports